import { Alert } from '@facile-it/shark-morph/components'
import { helperClassCssFixer } from '@facile-it/shark-morph/library'
import { SharkMorphProvider } from '@facile-it/shark-morph/providers'
import Bowser from 'bowser'
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from '../../../shark-lib/ts/services/ErrorBoundary/ErrorBoundary'
import { configureSentry } from './config/configureSentry'
import { CreateProspect } from './scenes/createProspect'

import '@facile-it/shark-morph/style/index.css'

declare let ENVIRONMENT: 'prod' | 'ci' | 'dev' | 'review' | 'staging'

const App: React.FC = () => {
    React.useEffect(() => {
        helperClassCssFixer()
        configureSentry()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [helperClassCssFixer, configureSentry])

    return (
        <SharkMorphProvider debug={ENVIRONMENT === 'dev' || ENVIRONMENT === 'ci'} application="webApp" theme="shark">
            <ErrorBoundary>
                <CreateProspect />
            </ErrorBoundary>
        </SharkMorphProvider>
    )
}

createRoot(document.getElementById('app-root') as HTMLElement).render(
    Bowser.getParser(window.navigator.userAgent).satisfies({ ie: '<11', safari: '<9' }) ? (
        <Alert type="info">
            Browser non supportato
            <br />
            Devi aggiornare il browser per poter utilizzare il sito
        </Alert>
    ) : (
        <App />
    )
)
